// src/auth/AuthContext.jsx
// Contexto global de autenticacion. Expone user, login, logout, loading.
// Sprint 15.
// Sprint 51 - DESACTIVADO. La autenticacion ahora la maneja
// src/hooks/useAuth.js. AuthProvider queda como passthrough para
// no romper a quien lo importe (AppRoutes lo monta en el arbol).

// const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  return children;
  /*
  const [user, setUser] = useState(() => apiClient.getUser());
  const [loading, setLoading] = useState(true);

  // Al montar, si hay token, lo validamos contra /auth/me
  useEffect(() => {
    const token = apiClient.getAccessToken();
    if (!token) {
      setLoading(false);
      return;
    }
    apiClient
      .get('/auth/me')
      .then((res) => {
        if (res?.user) {
          setUser(res.user);
          apiClient.setUser(res.user);
        }
      })
      .catch(() => {
        // apiClient ya limpio el storage y redirigio si procede
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const res = await apiClient.post('/auth/login', { username, password });
    if (res?.access_token) apiClient.setAccessToken(res.access_token);
    if (res?.refresh_token) apiClient.setRefreshToken(res.refresh_token);
    if (res?.user) {
      apiClient.setUser(res.user);
      setUser(res.user);
    }
    return res?.user;
  };

  const logout = () => {
    // Endpoint de cortesia; el token es stateless, asi que lo importante es limpiar storage
    apiClient.post('/auth/logout').catch(() => {});
    apiClient.clearAuth();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
  */
}

/*
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de <AuthProvider>');
  return ctx;
}
*/
